<template>
  <div>
    <div v-if="currentCreative.media_type == 'video'">
      <div>
        <div>
          <!-- 非进阶创意的编辑模式或主页广告：单视频展示 -->
          <div
            class="adCon-vertical"
            v-if="isFbPageAd || (edit && !advancedCreative)"
          >
            <upload-video
              ref="uploadVideo"
              from="fb"
              :accountId="accountId"
              :rowThirdNum="rowThirdNum"
              :adsMsg="currentCreative"
              @setVideoUrl="setVideoUrl"
              @setAdsMsg="setAdsMsg"
              @creatSlide="creatSlide"
              @deleImg="deleImg"
            ></upload-video>
            <!-- AI 视频标记 -->
            <div
              class="mt-2 mb-2"
              v-if="sourceMsg.source_id"
            >
              <!-- 不传 value：由组件根据 file-id 自行查询并维护标记，
                   避免 file-id(sourceMsg) 与 value(currentCreative) 不同源导致换素材后显示残留 -->
              <ai-usage-tag
                :file-id="sourceMsg.source_id"
                :disabled="sourceMsg.videoStatus !== 'ready'"
                @change="val => setCreativeMsg({ ...currentCreative, ai_tag: val })"
              />
            </div>
            <!-- 文案部分放到素材下面 -->
            <div
              class="imgForm imgForm-below"
              v-if="!isFbPageAd"
            >
              <advanced-copywriter
                v-if="advancedCreative"
                :creative="currentCreative"
                :accountId="accountId"
                :pageId="pageId"
                :instagramActorId="instagramActorId"
                @setCreativeMsg="setCreativeMsg"
              ></advanced-copywriter>
              <copywriter
                v-else
                :creative="currentCreative"
                :accountId="accountId"
                :pageId="pageId"
                :instagramActorId="instagramActorId"
                :mediaType="currentCreative.media_type"
                :webUrl="currentCreative.web_url"
                :actionType="currentCreative.action_type"
                @setCreativeMsg="setCreativeMsg"
              ></copywriter>
            </div>
            <!-- 编辑模式下的视频封面图部分 -->
            <div class="video-thumb-section">
              <div class="flex">
                <span>视频封面图：</span>
                <div class="mr-3">
                  <el-button
                    size="small"
                    @click="selectImg('img', 1)"
                    :disabled="!sourceMsg.source_id && sourceMsg.videoStatus != 'ready'"
                    >从创意云选择</el-button
                  >
                </div>
                <gm-upload-material
                  ref="uploadMaterial"
                  v-model:fileList="fileList"
                  :disabled="!sourceMsg.source_id"
                  :saveAdFileParams="saveAdFileParam"
                  :on-success="onSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button
                    size="small"
                    type="primary"
                    class="inline-block"
                    @click="uploadTypes = 'img'"
                    :disabled="!sourceMsg.source_id && sourceMsg.videoStatus != 'ready'"
                    >点击上传</el-button
                  >
                </gm-upload-material>
                <div class="ml-3">
                  <el-button
                    size="small"
                    :loading="thumbBtnLoading"
                    :disabled="!sourceMsg.source_id && sourceMsg.videoStatus != 'ready'"
                    @click="refreshThumb"
                    >刷新封面图</el-button
                  >
                </div>
              </div>
              <div
                class="adCon"
                style="margin-top: 10px"
              >
                <div
                  class="thumbList"
                  v-if="thumbList.length"
                >
                  <div
                    class="thumbWrap"
                    v-for="(img, thumbIndex) in thumbList"
                    :key="thumbIndex"
                    @click="setVideoThumb(img.uri, thumbIndex)"
                  >
                    <el-image
                      :src="img.uri"
                      fit="contain"
                    ></el-image>
                    <i
                      class="el-icon-circle-check"
                      v-if="img.isPreferred"
                    ></i>
                  </div>
                </div>
                <div
                  class="empty"
                  v-else
                  style="width: 100%"
                >
                  <span>
                    <i class="iconfont icon-wushuju"></i>
                    <p>暂无数据</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="imgMsg"
            v-else
          >
            <div
              class="imgCon"
              v-if="imgList.length < canUploadNum"
            >
              <el-button
                size="small"
                @click="selectImg('video', 30)"
                >从创意云选择</el-button
              >
              <el-button
                size="small"
                @click="creatSlide"
                >创建幻灯</el-button
              >
              <gm-upload-material
                ref="uploadMaterial"
                v-model:fileList="fileList"
                :saveAdFileParams="saveAdFileParam"
                :on-success="onSuccess"
                :before-upload="beforeUpload"
              >
                <el-button
                  size="small"
                  type="primary"
                  @click="uploadTypes = 'video'"
                  >点击上传</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                >
                  <img-tips></img-tips>
                </div>
              </gm-upload-material>
            </div>
            <div class="imgList">
              <div
                v-for="(img, index) in imgList"
                :key="`${img.id}`"
                class="video-item-wrap"
              >
                <video-item
                  class="imgCon"
                  :class="{
                    chooseNotReady: index == activeIndex && img?.videoStatus !== 'ready',
                    chooseNormal: index == activeIndex && img?.thumbUrl && img?.videoStatus === 'ready',
                    chooseNotNormal: index == activeIndex && !img?.thumbUrl && img?.videoStatus === 'ready',
                    notChooseNotNormal: index != activeIndex && !img?.thumbUrl && img?.videoStatus === 'ready',
                  }"
                  @changeImg="() => changeImg(index)"
                  :videoMsg="img"
                  @deleImg="() => deleImg(index)"
                  @setThumbList="setThumbList"
                  @setVideoItem="(v) => setVideoItem(v, index)"
                  :active="index == activeIndex"
                  :index="index"
                >
                </video-item>
                <!-- AI 视频标记 -->
                <div
                  class="text-center mt-1"
                  v-if="img.source_id"
                >
                  <ai-usage-tag
                    :file-id="img.source_id"
                    :value="img.ai_tag"
                    :disabled="img.videoStatus !== 'ready'"
                    @change="val => handleAiTagChange(val, index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 多素材模式下的文案编辑区域 -->
        <div
          class="imgForm"
          v-if="!(isFbPageAd || (edit && !advancedCreative))"
        >
          <template v-if="imgList.length || advancedCreative">
            <advanced-copywriter
              v-if="advancedCreative"
              :creative="currentCreative"
              :accountId="accountId"
              :pageId="pageId"
              :instagramActorId="instagramActorId"
              @setCreativeMsg="setAdvancedCreativeMsg"
            ></advanced-copywriter>
            <copywriter
              v-else
              :creative="currentImgMsg"
              :accountId="accountId"
              :pageId="pageId"
              :instagramActorId="instagramActorId"
              :mediaType="currentCreative.media_type"
              :webUrl="currentCreative.web_url"
              :actionType="currentCreative.action_type"
              @setCreativeMsg="setImgMsg"
            ></copywriter>
          </template>
          <span
            v-else
            style="color: #f00; font-size: 12px"
            >请先上传素材再填写文案哦~~</span
          >
        </div>
        <!-- 多素材模式下的视频封面图部分 -->
        <div
          class="video-thumb-section"
          v-if="!(isFbPageAd || (edit && !advancedCreative))"
        >
          <div class="flex">
            <span>视频封面图：</span>
            <div class="mr-3">
              <el-button
                size="small"
                @click="selectImg('img', 1)"
                :disabled="!currentImg.source_id && currentImg.videoStatus != 'ready'"
                >从创意云选择</el-button
              >
            </div>
            <gm-upload-material
              ref="uploadMaterialThumb"
              v-model:fileList="fileList"
              :disabled="!currentImg.source_id"
              :saveAdFileParams="saveAdFileParam"
              :on-success="onSuccess"
              :before-upload="beforeUpload"
            >
              <el-button
                size="small"
                type="primary"
                class="inline-block"
                @click="uploadTypes = 'img'"
                :disabled="!currentImg.source_id && currentImg.videoStatus != 'ready'"
                >点击上传</el-button
              >
            </gm-upload-material>
            <div class="ml-3">
              <el-button
                size="small"
                :loading="thumbBtnLoading"
                :disabled="!currentImg.source_id && currentImg.videoStatus != 'ready'"
                @click="refreshThumb"
                >刷新封面图</el-button
              >
            </div>
          </div>
          <div
            class="adCon"
            style="margin-top: 10px"
          >
            <div
              class="thumbList"
              v-if="thumbList.length"
            >
              <div
                class="thumbWrap"
                v-for="(img, thumbIndex) in thumbList"
                :key="thumbIndex"
                @click="setVideoThumb(img.uri, thumbIndex)"
              >
                <el-image
                  :src="img.uri"
                  fit="contain"
                ></el-image>
                <i
                  class="el-icon-circle-check"
                  v-if="img.isPreferred"
                ></i>
              </div>
            </div>
            <div
              class="empty"
              v-else
              style="width: 100%"
            >
              <span>
                <i class="iconfont icon-wushuju"></i>
                <p>暂无数据</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img-list
      :adSeriesInfo="adSeriesInfo"
      :imgListShow="imgListShow"
      :saveAdFileParam="saveAdFileParam"
      :adMaterialParams="adMaterialParams"
      @close="imgListShow = false"
      @urlList="urlList"
      :uploadTypes="uploadTypes"
      :limit="limit"
    ></img-list>
    <creat-slide
      :adSlideShow="adSlideShow"
      :saveAdFileParam="saveAdFileParam"
      @close="adSlideShow = false"
      @getVideoFile="getVideoFile"
    ></creat-slide>
  </div>
</template>
<script>
import tools from '../tools';
import adsMethods from '../../adsMethods';
import imgList from '@/views/adManagement/createAd/components/imgList.vue';
import imgTips from './imgTips.vue';
import copywriter from './copywriter.vue';
import advancedCopywriter from './advancedCopywriter.vue';
import uploadVideo from '../uploadVideo.vue';
import videoItem from './videoItem.vue';
import creatSlide from '../creatSlide.vue';
import { saveVideoThumb } from '@/api/creatAd.js';
import { AiUsageTag } from '@adCommonComponent';

export default {
  mixins: [tools, adsMethods],
  props: {
    adSeriesInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    currentCreative: {
      type: Object,
      default: () => {},
    },
    isFbPageAd: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    rowThirdNum: {
      type: String | Number,
      default: '',
    },
    accountId: {
      type: String | Number,
      default: '',
    },
    advancedCreative: {
      type: Boolean,
      default: false,
    },
    pageId: {
      type: [String, Number],
      default: '',
    },
    instagramActorId: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    imgList,
    imgTips,
    copywriter,
    advancedCopywriter,
    uploadVideo,
    videoItem,
    creatSlide,
    AiUsageTag,
  },
  data() {
    return {
      index: 0,
      imgListShow: false,
      activeIndex: 0,
      uploadTypes: 'video',
      thumbListMap: {},
      adSlideShow: false,
      uplaodType: 'video',
      defaultCopywriter: { copywriter: { title: '', content: '' }, message: '' },
      sourceMsg: {
        uploadNums: 0,
        videoStatus: null,
      },
      limit: 1,
    };
  },
  computed: {
    canUploadNum() {
      // 进阶创意模式下素材限制为10个，普通模式30个
      return this.advancedCreative ? 10 : 30;
    },
    currentImgMsg() {
      const currentImg = this.imgList[this.activeIndex];
      if (!currentImg) {
        return {
          copywriter: { title: '', content: '' },
          message: '',
          fbAssetFeedSpec: {
            titles: [''],
            mDescriptions: [''],
            mBodies: [''],
            imgList: [],
            videos: [],
            mAdFormats: ['AUTOMATIC_FORMAT'],
            actionTypes: [],
            linkUrls: [''],
          },
        };
      }
      // 进阶创意模式下，返回包含fbAssetFeedSpec的对象
      if (this.advancedCreative) {
        return {
          ...currentImg,
          fbAssetFeedSpec: this.currentCreative.fbAssetFeedSpec,
        };
      }
      // 直接返回当前图片对象，确保包含所有属性
      return currentImg;
    },
    imgList: {
      get() {
        // 进阶创意模式下，从fbAssetFeedSpec.videos获取
        if (this.advancedCreative) {
          return this.currentCreative.fbAssetFeedSpec?.videos || [];
        }
        return this.currentCreative.imgList || [];
      },
      set(v) {
        if (this.advancedCreative) {
          // 进阶创意模式下，更新fbAssetFeedSpec.videos
          const fbAssetFeedSpec = {
            ...this.currentCreative.fbAssetFeedSpec,
            videos: v,
          };
          this.$emit('setCreativeMsg', { fbAssetFeedSpec });
        } else {
          this.setCreativeMsg(v);
        }
      },
    },
    currentImg() {
      return this.imgList[this.activeIndex] || {};
    },
    thumbList() {
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        return this.thumbListMap[this.currentCreative.source_id] || [];
      } else {
        return this.thumbListMap[this.imgList[this.activeIndex]?.source_id] || [];
      }
    },
    disabledBtn() {
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        return !this.sourceMsg.source_id && !this.sourceMsg.videoStatus != 'ready';
      } else {
        return !this.currentImg.source_id && !this.currentImg.videoStatus != 'ready';
      }
    },
  },
  watch: {
    sourceMsg: {
      handler() {
        this.$emit('setCreativeMsg', { ...this.currentCreative, ...this.sourceMsg });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    refreshThumb() {
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.$showLoading();
        this.$refs.uploadVideo.getVideoUrlEdit(this.sourceMsg.videoId, this.sourceMsg.sourceType);
      } else {
        this.getVideoUrl(this.currentImg.videoId, this.currentImg.sourceType);
      }
    },
    // AI 视频标记变更（多视频模式）
    handleAiTagChange(val, index) {
      const newImgList = [...this.imgList];
      newImgList[index] = { ...newImgList[index], ai_tag: val };
      this.setCreativeMsg(newImgList);
    },
    /* 文件上传成功返回数据 */
    onSuccess(response, file) {
      console.log(response, file, 'onSuccess');
      if (response?.status == 'error') {
        this.$notify.error({
          title: '错误',
          message: `${response.name}上传失败`,
          duration: 0,
        });
        return;
      }
      if (this.uploadTypes === 'img') {
        // 非进阶创意的编辑模式或主页广告
        const imgData = (this.edit && !this.advancedCreative) || this.isFbPageAd ? this.sourceMsg : this.currentImg;
        const videoFileId = imgData.source_id;
        const params = {
          videoFileId: videoFileId,
          videoThumbUrl: response.url,
        };
        this.uploadThumb(params, 'bendi');
        return;
      }
      console.log(this.edit, this.isFbPageAd, 'this.edit || this.isFbPageAd');
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.uploadVideoFb(response.id, response.sourceType, response.mediaOptLogId);
      } else if (this.advancedCreative) {
        // 进阶创意模式下，转换为fbAssetFeedSpec.videos的格式
        const newVideo = {
          id: response.id, // videoItem组件需要id字段来调用uploadVideoFb
          source_id: response.id,
          url: response.url,
          sourceType: response.sourceType,
          mediaSourceType: response.sourceType,
          mediaOptLogId: response.mediaOptLogId,
          thumbUrl: '',
          videoStatus: 'processing',
        };
        const newIndex = this.imgList.length;
        // 进阶创意模式下素材限制为10个
        this.imgList = this.imgList.concat(newVideo).slice(0, 10);
        // 上传完成后自动选中新素材
        this.$nextTick(() => {
          this.autoSelectNewVideo(newIndex);
        });
      } else {
        response.videoStatus = 'processing';
        response.source_id = response.id;
        response.mediaOptLogId = response.mediaOptLogId;
        const newIndex = this.imgList.length;
        this.imgList = this.imgList.concat({ ...response }).slice(0, 30);
        // 上传完成后自动选中新素材
        this.$nextTick(() => {
          this.autoSelectNewVideo(newIndex);
        });
        console.log(this.imgList, 'this.imgList');
      }
    },
    // 接收上传视频的信息（编辑）
    setAdsMsg(index, msg, isupload) {
      console.log(msg, 'setAdsMsg');

      let message = { ...this.currentCreative, ...msg };
      this.thumbListMap[msg.source_id] = msg.thumbList;
      this.sourceMsg = { ...this.sourceMsg, ...msg };
      // this.setCreativeMsg(message)
      // this.setVideoThumb(msg.thumbList[0].uri, 0, 0, isupload);
    },
    // 保存视频封面
    uploadThumb(formData, type, acIndex) {
      this.$showLoading();
      // 非进阶创意的编辑模式或主页广告
      const imgData = (this.edit && !this.advancedCreative) || this.isFbPageAd ? this.sourceMsg : this.currentImg;
      console.log(imgData, 'imgData');

      const sourceType = imgData.sourceType;
      const videoFileId = imgData.source_id;
      const params = {
        ...formData,
        sourceType: formData.sourceType || sourceType,
        uid: this.userInfo.id,
        orgCode: this.userInfo.orgCode,
        accountId: this.$store.getters.accountId,
      };
      // let activeIndex = acIndex || acIndex === 0 ? acIndex : this.activeIndex;
      saveVideoThumb(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '上传成功',
            });
            const thumbUrl = res.data.thumbUrl;

            // this.imgList[this.activeIndex].thumbUrl = res.data.thumbUrl;
            // 非进阶创意的编辑模式或主页广告
            if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
              this.$set(this.sourceMsg, 'thumbUrl', thumbUrl);
              this.setCreativeMsg(this.sourceMsg);
            } else {
              let index = this.imgList.findIndex((v) => v.source_id == formData.videoFileId && !v.thumbUrl);
              index = index === -1 ? this.activeIndex : index;
              this.$set(this.imgList[index], 'thumbUrl', thumbUrl);
              this.setCreativeMsg(this.imgList);
            }
            console.log(
              (this.edit && !this.advancedCreative) || this.isFbPageAd,
              this.activeIndex,
              videoFileId,
              this.imgList,
              'saveVideoThumb',
            );
            if (type && type == 'bendi') {
              let obj = {
                isPreferred: true,
                uri: thumbUrl,
              };
              // 非进阶创意的编辑模式或主页广告
              let key =
                (this.edit && !this.advancedCreative) || this.isFbPageAd
                  ? this.sourceMsg.source_id
                  : this.currentImg.source_id;
              this.thumbListMap[key].map((v) => (v.isPreferred = false));
              this.thumbListMap[key].unshift(obj);
            }
            this.$forceUpdate();
          }
        })
        .finally(() => {
          this.$hideLoading();
        });
    },
    // 点击封面设置封面
    setVideoThumb(url, index) {
      // 非进阶创意的编辑模式或主页广告
      const imgData = (this.edit && !this.advancedCreative) || this.isFbPageAd ? this.sourceMsg : this.currentImg;
      const key = imgData.source_id;
      if (index || index === 0) {
        this.thumbListMap[key].map((v, ind) => {
          if (index == ind) {
            this.$set(this.thumbListMap[key][ind], 'isPreferred', true);
          } else {
            this.$set(this.thumbListMap[key][ind], 'isPreferred', false);
          }
        });
      }
      const params = {
        videoFileId: key,
        videoThumbUrl: url,
      };
      this.uploadThumb(params, null, this.activeIndex);
    },
    setThumbList(list, id, sourceType) {
      console.log('aaaaa', list, id, sourceType);
      this.$set(this.thumbListMap, id, list);
      let uri = list.find((v) => v.isPreferred).uri;
      const params = {
        videoFileId: id,
        videoThumbUrl: uri,
        sourceType,
      };
      this.uploadThumb(params, null);
      // this.thumbListMap[id] = list
    },
    // 创建幻灯广告
    creatSlide() {
      this.adSlideShow = true;
    },
    // 接收幻灯片视频（创建的时候）
    getVideoFile(file) {
      this.adSlideShow = false;
      this.imgList = this.imgList.concat(file).slice(0, 30);
      if (this.isFbPageAd || this.edit) {
        this.$refs.uploadVideo.onSuccess(file);
      }
    },
    // 接收幻灯片地址(编辑的时候)
    setVideoUrl(v, thumbList, index) {
      console.log('setVideoUrl', v, thumbList, index);
      this.adSlideShow = false;
      if (this.currentCreative.media_type != 'video') return false;
      let message = {
        ...this.currentCreative,
        image: v.url,
        source_id: v.id,
        sourceType: v.mediaSourceType,
        videoStatus: 'processing',
      };
      this.setCreativeMsg(message);
      this.thumbListMap[v.id] = thumbList;
      // this.setVideoThumb(thumbList.filter((v) => v.isPreferred)[0].uri, i);
      const url = thumbList.filter((v) => v.isPreferred)[0].uri;
      const params = {
        videoFileId: v.id,
        videoThumbUrl: url,
      };
      this.uploadThumb(params);
    },
    // 点击素材库上传
    selectImg(type, num) {
      this.uploadTypes = type;
      this.limit = num || 1;
      // 非进阶创意的编辑模式或主页广告：单素材
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.limit = 1;
      }
      // 进阶创意模式下支持多选，最多选择剩余可用数量
      if (this.advancedCreative && type === 'video') {
        const remainingSlots = this.canUploadNum - this.imgList.length;
        this.limit = Math.max(1, remainingSlots);
      }
      this.imgListShow = true;
    },
    // 修改创意
    setCreativeMsg(v) {
      if (this.isFbPageAd || this.edit) {
        this.$emit('setCreativeMsg', v);
      } else {
        this.$emit('setCreativeMsg', { imgList: v });
      }
    },
    // 自动选中新上传的素材并初始化文案
    autoSelectNewVideo(index) {
      this.setCopyWriter(index);
      this.activeIndex = index;
      this.$emit('setPreviewIndex', this.activeIndex);
    },
    // 进阶创意模式下修改文案
    setAdvancedCreativeMsg(v) {
      this.$emit('setCreativeMsg', v);
    },
    setVideoItem(v, index) {
      this.imgList[index] = { ...this.imgList[index], ...v };
      this.setCreativeMsg(this.imgList);
    },
    // 修改文案
    setImgMsg(v, key) {
      const newImgList = [...this.imgList];
      newImgList[this.activeIndex] = { ...newImgList[this.activeIndex], ...v };
      this.setCreativeMsg(newImgList);
    },
    // 获取素材库图片
    async urlList(v, sourceType) {
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        if (this.uplaodTypes == 'video') {
          await this.uploadVideoFb(v[v.length - 1].id, sourceType, v[v.length - 1].mediaOptLogId);
        } else {
          this.$emit('setCreativeMsg', {
            ...this.currentCreative,
            image: v[v.length - 1].url,
            source_id: v[v.length - 1].id,
          });
        }
      } else {
        if (this.uploadTypes == 'video') {
          if (this.advancedCreative) {
            // 进阶创意模式下，转换为fbAssetFeedSpec.videos的格式
            const newVideos = v.map((m) => ({
              id: m.id, // videoItem组件需要id字段来调用uploadVideoFb
              source_id: m.id,
              url: m.url,
              sourceType: m.sourceType,
              mediaSourceType: m.sourceType,
              mediaOptLogId: m.mediaOptLogId,
              thumbUrl: '',
              videoStatus: 'processing',
            }));
            const newIndex = this.imgList.length;
            // 进阶创意模式下素材限制为10个
            this.imgList = this.imgList.concat(newVideos).slice(0, 10);
            // 从素材库选择后自动选中新素材
            this.$nextTick(() => {
              this.autoSelectNewVideo(newIndex);
            });
          } else {
            const newIndex = this.imgList.length;
            this.imgList = this.imgList
              .concat(
                v.map((m) => {
                  return { ...m, source_id: m.id, videoStatus: 'processing' };
                }),
              )
              .slice(0, 30);
            // 从素材库选择后自动选中新素材
            this.$nextTick(() => {
              this.autoSelectNewVideo(newIndex);
            });
          }
        } else {
          let img = v[v.length - 1];
          let obj = {
            isPreferred: true,
            uri: img.url,
          };
          // console.log(obj);
          this.thumbListMap[this.currentImg.source_id].unshift(obj);
          this.setVideoThumb(img.url, 0);
        }
      }
    },
    // 设置文案
    setCopyWriter(index) {
      let data = this.imgList[index];
      // 同步 title 数组（与 message 处理方式一致，传递完整数组）
      if (!data.title || (Array.isArray(data.title) && !data.title.some((t) => t && t.trim()))) {
        const defaultTitleArr = this.defaultTitle(this.imgList);
        data.title = [...defaultTitleArr];
      }
      // 同步 content 数组（与 message 处理方式一致，传递完整数组）
      if (!data.content || (Array.isArray(data.content) && !data.content.some((c) => c && c.trim()))) {
        const defaultContentArr = this.defaultContent(this.imgList);
        data.content = [...defaultContentArr];
      }
      // 兼容旧逻辑：确保 copywriter 对象存在
      if (!data.copywriter) {
        this.$set(data, 'copywriter', { title: '', content: '' });
      }
      if (!data.message) data.message = this.defaultMessage(this.imgList);
    },
    // 点击选择图片切换广告语
    changeImg(index) {
      console.log(index);
      this.setCopyWriter(index);
      this.activeIndex = index;
      this.$emit('setPreviewIndex', this.activeIndex);
    },
    // 点击删除图片
    deleImg(index) {
      // 非进阶创意的编辑模式或主页广告
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.$emit('setCreativeMsg', { ...this.currentCreative, image: '' });
      } else {
        const newImgList = [...this.imgList];
        newImgList.splice(index, 1);
        this.imgList = newImgList;
        if (this.activeIndex >= newImgList.length) {
          this.activeIndex = Math.max(0, newImgList.length - 1);
        }
        this.$emit('setPreviewIndex', this.activeIndex);
      }
    },
    // 上传图片
    // upload_img(file) {
    //   this.uploadImg(file)
    //     .then((data) => {
    //       if (data.status == 'error') {
    //         this.$notify.error({
    //           title: '错误',
    //           message: `${file.file.name}上传失败`,
    //           duration: 0,
    //         });
    //       } else {
    //         console.log(this.edit, this.isFbPageAd, 'this.edit || this.isFbPageAd');
    //         if (this.edit || this.isFbPageAd) {
    //           this.uploadVideoFb(data.id, 'SELF_MATERIAL');
    //         } else {
    //           data.videoStatus = 'processing';
    //           data.source_id = data.id;
    //           this.imgList = this.imgList.concat({ ...data, videoStatus: 'processing' }).slice(0, 30);
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
.imgCon {
  width: 220px;
  height: 220px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 15px;
  margin-right: 8px;
  // overflow: hidden;
  position: relative;
  margin: 5px;

  video {
    width: 100%;
    height: 100%;
  }

  .delete {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 2;
    font-size: 18px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
  }
}

.imgMsg {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;

  .imgList {
    flex: 1;
    overflow-x: auto;
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    overflow-y: hidden;

    .video-item-wrap {
      flex-shrink: 0;
    }

    .imgCon {
      flex-shrink: 0;
      border: 3px solid transparent;
      &.active {
        border-color: #409eff;
      }
      &.chooseNotReady {
        border: 3px solid #409eff;
      }
      &.chooseNormal {
        border: 3px solid #409eff;
      }
      &.chooseNotNormal {
        border: 3px solid #f56c6c;
      }
      &.notChooseNotNormal {
        border: 3px dashed #f56c6c;
      }
    }
  }
}

.imgForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}

// 垂直布局：素材在上，文案在下
.adCon-vertical {
  display: flex;
  flex-direction: column;

  // 隐藏uploadVideo组件内部的imgList弹窗容器（它是空的占位元素）
  ::v-deep > .imgCon > .imgList {
    position: absolute;
    visibility: hidden;
    pointer-events: none;
  }

  .imgForm-below {
    width: 100%;
    margin-left: 0;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
  }
}

// 视频封面图区域
.video-thumb-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;

  .thumbList {
    margin-top: 10px;
  }
}
</style>
